/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-09T17:19:06.606
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportRentContract,
	listReportRentContractInit,
	listReportRentContractByAuthorizations,
	deleteReportRentContract
	
} from '@api/report/ReportRentContract';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportRentContract({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContract(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportRentContractByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportRentContractInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportRentContract({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportRentContract({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
